/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetHierarchyQueryResponse, HierarchiesControllerGetHierarchyQueryParams, HierarchiesControllerGetHierarchy401, HierarchiesControllerGetHierarchy403 } from "../../models/hierarchiesController/HierarchiesControllerGetHierarchy";

function getHierarchiesControllerGetHierarchyUrl() {
  const res = { method: 'GET', url: `/api/v1/hierarchies/me` as const }  
  return res
}

/**
 * @description Retrieve complete hierarchy information with full JSON:API compliant structure. Supports lazy loading and pagination of children.
 * @summary Get user hierarchy
 * {@link /api/v1/hierarchies/me}
 */
export async function hierarchiesControllerGetHierarchy(params?: HierarchiesControllerGetHierarchyQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<HierarchiesControllerGetHierarchyQueryResponse, ResponseErrorConfig<HierarchiesControllerGetHierarchy401 | HierarchiesControllerGetHierarchy403>, unknown>({ method : "GET", url : getHierarchiesControllerGetHierarchyUrl().url.toString(), params, ... requestConfig })  
  return res.data
}